import { render, staticRenderFns } from "./corporate.vue?vue&type=template&id=2ccf7e1f&scoped=true&"
import script from "./corporate.vue?vue&type=script&lang=js&"
export * from "./corporate.vue?vue&type=script&lang=js&"
import style0 from "./corporate.vue?vue&type=style&index=0&id=2ccf7e1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccf7e1f",
  null
  
)

export default component.exports